import { useFormContext } from "react-hook-form";
import { Box, Typography } from "@mui/material";
import { Moment } from "moment";
import TableView from "../TableView";

export default function InfoStep02() {

  const { getValues } = useFormContext()
  const { step02 } = getValues()
  const isParcelado = step02.is_parcelado === 'true'
  const parcelas: TParcelas[] = step02.parcelas

  return (
    <>
      <Box display={'flex'} flexDirection={'column'} >
        <Box display={'flex'} gap={4}>
          <TableView
            title="Emissão"
            text={`${step02.data_emissao.format('DD/MM/YYYY')}`}
          />

          {
            !isParcelado &&
            <TableView
              title="Data de vencimento"
              text={`${step02.data_vencimento.format('DD/MM/YYYY')}`}
            />
          }

          <TableView
            title="Valor"
            text={`${step02.valor_total}`}
          />
        </Box>

        {
          isParcelado && parcelas.length > 0 &&
          <>
            <Typography variant="subtitle2" color="textSecondary">Parcelamento</Typography>

            <Box overflow={'auto'} display={'flex'} maxHeight={280} flexDirection={'column'} flexWrap={'wrap'} gap={0}>
              {
                parcelas.map((item: TParcelas, index) => {
                  return (
                    <Typography mr={1} variant="subtitle1" key={index}>{item.numero_parcela}ª) {item.valor_parcela} ............ {item.data_vencimento.format('DD/MM/YYYY')}</Typography>
                  )
                })
              }
            </Box>
          </>
        }
      </Box>
    </>
  )
}



export type TParcelas = {
  valor_parcela: string,
  numero_parcela: number,
  data_vencimento: Moment
}